export default class EmissionsData {
  constructor(fuelLowSulfur, fuelOil) {
    this.fuelLowSulfur = fuelLowSulfur,
    this.fuelOil = fuelOil;
  }

  get totalEmissions() {
    return this.fuelLowSulfur + this.fuelOil;
  }
}
